import React from 'react'

export default function addBarcode(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
            className='st1'
          fill-opacity=".1"
          d="M23.82 16H10.94A1.94 1.94 0 0 0 9 17.94v11.42a1.94 1.94 0 0 0 1.94 1.94h12.88a1.94 1.94 0 0 0 1.94-1.94V17.94A1.94 1.94 0 0 0 23.82 16Z"
        />
        <path
          className='st2'
          d="M22.98 24.05c0 3.16-2.52 5.72-5.64 5.72-3.12 0-5.64-2.56-5.64-5.72 0-3.16 2.52-5.72 5.64-5.72v5.72h5.64Z"
        />
        <path
          className='st1'
          d="M23.69 23.28h-5.64v-5.72c3.11 0 5.64 2.56 5.64 5.72Z"
        />
        <path
          className='st1'
          d="M30.32 9.44v21.7c0 1.68-1.4 2.99-2.99 2.99H6.65c-1.68 0-2.99-1.4-2.99-2.99V4.95c0-1.68 1.31-3.09 2.99-3.09h16.09c.47 0 1.03.19 1.31.56l5.71 5.61c.28.37.56.84.56 1.4v.01Z"
          opacity=".3"
        />
        <path
          className='st1'
          d="m30.7 7.52-5.99-5.8c-.28-.37-.84-.56-1.31-.56H6.56a3.15 3.15 0 0 0-3.18 3.18v27.32c0 1.78 1.4 3.18 3.18 3.18h21.61c1.78 0 3.18-1.4 3.18-3.09V9.11c.09-.65-.19-1.22-.65-1.59Zm-.47 23.3c0 1.59-1.31 2.99-2.9 2.99H7.4c-1.59 0-2.9-1.31-2.9-2.99V5.18c0-1.59 1.31-2.99 2.9-2.99h15.44c.47 0 .94.19 1.31.56l5.52 5.43c.37.37.65.94.56 1.5v21.14Z"
        />
        <path
          className='st1'
          d="M1.61 4.9h15.66c.51 0 .92.42.92.96v6.01c0 .53-.41.96-.92.96H.69V5.87c0-.53.41-.94.92-.94V4.9Z"
        />
        <path
          className='st2'
          d="M18.18 11.74v.12c0 .53-.41.96-.92.96H.69V5.86c0-.53.41-.96.92-.96h.48v2.47c0 2.41 1.87 4.37 4.2 4.37h11.9-.01Z"
          opacity=".3"
        />
        <path
          className='st1'
          fill-opacity=".5"
          d="m.63 12.8 2.78 3.28V12.8H.63Z"
          opacity=".3"
        />
        <path
          className='st3'
          d="M3.442 11V5.91h2.009c.386 0 .715.073.987.22.272.146.479.35.621.61.144.258.217.556.217.894 0 .338-.073.637-.22.895-.145.259-.356.46-.633.604-.275.144-.608.216-1 .216h-1.28v-.862H5.25c.207 0 .377-.036.512-.107a.709.709 0 0 0 .303-.3.942.942 0 0 0 .102-.446.918.918 0 0 0-.102-.442.68.68 0 0 0-.303-.296 1.108 1.108 0 0 0-.517-.107h-.726V11H3.442Zm4.533 0V5.91h2.008c.386 0 .715.073.987.22.272.146.479.35.621.61.145.258.217.556.217.894 0 .338-.073.637-.219.895-.146.259-.357.46-.634.604-.275.144-.608.216-1 .216h-1.28v-.862h1.107c.207 0 .378-.036.512-.107a.709.709 0 0 0 .303-.3.942.942 0 0 0 .102-.446.918.918 0 0 0-.102-.442.68.68 0 0 0-.303-.296 1.107 1.107 0 0 0-.517-.107H9.05V11H7.975Zm4.338-4.203v-.888h4.181v.888h-1.559V11h-1.063V6.797h-1.559Z"
        />
      </svg>
    </div>
  )
}
